import { createFileRoute } from '@tanstack/react-router';
import { TrackEditor } from '@/components/tracks/TrackEditor.tsx';

export const Route = createFileRoute('/_app/tracks/$id/edit')({
  staticData: { orgScope: 'record', orgScopeList: '/tracks' },
  component: EditTrackPage,
});

function EditTrackPage() {
  const { id } = Route.useParams();

  return <TrackEditor trackId={id} />;
}
